import React from 'react';
import {
  Box,
  Typography,
  Paper,
  Alert
} from '@mui/material';

const ActivityLogPageSimple: React.FC = () => {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        سجل النشاط
      </Typography>
      
      <Paper sx={{ p: 3 }}>
        <Alert severity="info">
          صفحة سجل النشاط قيد التطوير...
        </Alert>
        
        <Typography variant="body1" sx={{ mt: 2 }}>
          هذه الصفحة ستعرض سجل شامل لجميع الأنشطة في النظام بما في ذلك:
        </Typography>
        
        <ul>
          <li>عمليات الصيانة (إنشاء، تحديث، حذف، تغيير حالة)</li>
          <li>عمليات العملاء (إنشاء، تحديث، حذف)</li>
          <li>عمليات الصور (رفع، حذف)</li>
          <li>عمليات المستخدمين (تسجيل دخول/خروج)</li>
          <li>عمليات الطباعة (إيصالات، ضمانات، فواتير)</li>
        </ul>
      </Paper>
    </Box>
  );
};

export default ActivityLogPageSimple;
